import images from "../../assets/images";
import { CUSTOMER_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "",
    field: "isLocked",
    width: 25,
    locked: true,
    floatingFilter: false,
    resizable: false,
    hide: false,
  },
  {
    headerName: "Customer Name",
    field: "patientName",
    width: 380,
  },
  {
    headerName: "Category",
    field: "patientCategory",
    width: 130,
  },
  {
    headerName: "Customer Identifier",
    field: "patientIdentifier",
    width: 150,
  },
  {
    headerName: "Entity",
    field: "entityName",
    width: 150,
  },
  {
    headerName: "Customer Type",
    field: "patientType",
    width: 120,
  },
  {
    headerName: "Contact Number",
    field: "patientPhone",
    width: 100,
  },
  {
    headerName: "Phone/Landline Number",
    field: "landlineNumber",
    width: 150,
  },
  {
    headerName: "Email",
    field: "patientEmail",
    width: 100,
  },
  {
    headerName: "Bank Name",
    field: "bankName",
    width: 100,
  },
  {
    headerName: "Account No",
    field: "accountNo",
    width: 120,
  },
  {
    headerName: "Credit Days",
    field: "creditDays",
    width: 100,
  },
  {
    headerName: "Credit Limit",
    field: "creditLimit",
    width: 100,
  },
  {
    headerName: "Remark",
    field: "remarks",
    width: 100,
  },
  {
    headerName: "Address",
    field: "patientAddress",
    width: 130,
  },
  {
    headerName: "State",
    field: "state",
    width: 120,
  },
  {
    headerName: "City",
    field: "patientCity",
    width: 120,
  },
  {
    headerName: "Area",
    field: "area",
    width: 120,
  },
  {
    headerName: "Pincode",
    field: "patientPincode",
    width: 120,
  },
  {
    headerName: "Food License",
    field: "foodLicense",
    width: 100,
  },
  {
    headerName: "Drug License",
    field: "drugLicense",
    width: 100,
  },
  {
    headerName: "Pan Number",
    field: "panNumber",
    width: 100,
  },
  {
    headerName: "GSTIN",
    field: "gstin",
    width: 100,
  },
  {
    headerName: "GSTIN Type",
    field: "gstinType",
    width: 120,
  },
  {
    headerName: "Payment Mode",
    field: "paymentMode",
    width: 100,
  },
  {
    headerName: "Billing Rate",
    field: "billingRate",
    width: 100,
  },
  {
    headerName: "Discount Style",
    field: "discountStyle",
    width: 100,
  },
];

export const columnDefsFunctions = {
  isLocked: {
    cellRendererFramework: (params) => {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {params.data.isLocked && <img src={images.locked} alt="" />}
        </div>
      );
    },
    // headerComponentFramework: (params) => {
    //   return <img src={images.locked} alt="" />;
    // },
  },
  patientCategory: {
    valueGetter: (params) => {
      if (params.data?.patientCategory)
        return params.data?.patientCategoryData?.name;
      else return "";
    },
  },

  entityName: {
    valueGetter: (params) => {
      if (params.data?.entityId) return params.data?.entityData?.entityName;
      else return "";
    },
  },

  bankName: {
    valueGetter: (params) => {
      if (params.data?.patientBankId)
        return params.data?.patientBankData?.bankName;
      else return "";
    },
  },
  accountNo: {
    valueGetter: (params) => {
      if (params.data?.patientBankId)
        return params.data?.patientBankData?.accountNo;
    },
  },
};

export const transformPayload = (data) => {
  delete data.patientBankData;
  delete data.patientCategoryData;
  delete data.entityData;
  return data;
};
export const gstinTypeOptions = [
  { id: "Registered", label: "Registered" },
  { id: "Unregistered", label: "Unregistered" },
];

export const discountStyleOptions = [
  {
    id: "Platinum card holder",
    label: "Platinum card holder",
  },
  { id: "B2B customers", label: "B2B customers" },
  {
    id: "corporate customer category",
    label: "corporate customer category",
  },
];

export const customerTypeOptions = [
  { id: "B2C", label: "B2C" },
  { id: "B2B", label: "B2B" },
];

export const billingRates = [
  "MRP",
  "Pur Rate",
  "Eff.Pur Rate",
  "PTR",
  "WA Rate",
];

export const paymentModes = [
  { id: "2SF", label: "CREDIT" },
  { id: "1SF", label: "CASH" },
  { id: "7SF", label: "UPI" },
  { id: "6SF", label: "CARD" },
  { id: "3SF", label: "CHEQUE" },
];

export const initial_state_customers = {
  type: CUSTOMER_TAB,
  label: "Customer",
  allowMultipleTabs: false,
};
